import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime } from 'rxjs';
import { Entities } from 'src/app/core/models/globals';
import { HeaderService } from 'src/app/core/services/header.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { ThemeService } from 'src/app/core/services/theme.service';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserRoleNames } from 'src/app/core/models/users';

@Component({
  selector: 'app-theme-config',
  templateUrl: './theme-config.component.html',
  styleUrls: ['./theme-config.component.scss']
})
export class ThemeConfigComponent implements OnInit {

  themeForm: FormGroup;
  existingTheme: any = this._themeService.getTheme();
  themeKeys = Object.keys(this.existingTheme);
  isSaved: boolean = false;
  currentEntity: Entities = Entities.Configurator;
  activeEntity: any;
  activeChild: string = "";
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;

  constructor(
    private _themeService: ThemeService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private navService: NavigationService,
    private headerService: HeaderService,
    private configEntityService: ConfigEntityService,
    private _router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.configEntityService.sendActiveEntity('Theme');
    this.navService.sendChildData('Theme');
    this.navService.sendParentData('');
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.themeForm = this.createDynamicForm(this.existingTheme);
    this.themeForm.valueChanges.pipe().subscribe((data) => {
      this._themeService.updateTheme(data);
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if(!this.isSaved){
      this._themeService.updateTheme(this.existingTheme);

    }
    if (this.currentEntity == Entities.Configurator) {
      //this.navService.sendLeftPanelIndex();
      this.configEntityService.sendActiveEntity("Theme")
      this.navService.sendChildData("Theme")
    }
  }

  createDynamicForm(dataObject: any): FormGroup {
    const formGroupConfig: { [key: string]: any } = {};

    Object.keys(dataObject).forEach((key) => {
      formGroupConfig[key] = [dataObject[key]]; // Initialize each control with an empty string
    });

    const dynamicForm = this.fb.group(formGroupConfig);

    return dynamicForm;
  }

  changeTheme(theme: string) {
    // this._themeService.changeTheme(theme);
  }

  onSave(){
    this.spinner.show("themeConfigSpinner")
    this.isSaved = true;
    this._themeService.updateThemesJson(JSON.stringify(this.themeForm.value)).subscribe({
      next: (data) => {
        this._themeService.themesJson = this.themeForm.value;
        this.snackBar.open("Theme updated successfully", "close", {duration: 3000})
        window.location.reload();
      },
      error: (error) => {
        this.snackBar.open("Error while updating theme", "close", {duration: 3000})
        this.spinner.hide("themeConfigSpinner")
      }
    });
  }

  redirectTo() {
    this.navService.sendParentData('')
    this._router.navigate(['../../../..'], { relativeTo: this.route })
  }

}
